import { render, staticRenderFns } from "./PDFThumbnail.vue?vue&type=template&id=0fedfa6b&scoped=true"
import script from "./PDFThumbnail.vue?vue&type=script&lang=js"
export * from "./PDFThumbnail.vue?vue&type=script&lang=js"
import style0 from "./PDFThumbnail.vue?vue&type=style&index=0&id=0fedfa6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedfa6b",
  null
  
)

export default component.exports